import { Presenter } from '@shared/presenters/presenter';
import type { Media } from './media';

export class MediaPresenter extends Presenter<Media> {

    get fileType() {
        return this._get('mimeType', () => {
            const mimeType = this.get('mime_type');

            if (mimeType.substr(0, 6) === 'image/') {
                return 'Image';
            }

            if (mimeType.substr(0, 6) === 'video/') {
                return 'Video';
            }

            switch (mimeType) {
                case null:
                    return 'Unknown file type';

                case 'application/vnd.ms-office':
                    return 'Office Document';

                case 'application/msword':
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    return 'Word Document';

                case 'application/vnd.ms-excel':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    return 'Excel Spreadsheet';

                case 'application/vnd.ms-powerpoint':
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                    return 'Powerpoint Presentation';

                case 'application/pdf':
                    return 'PDF Document';
            }
        });
    }

}
